import MetaBillingsCargoTaxiStatusCountersRequest from "../../../../../api/raily/meta/billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters.request";
import MetaBillingsCargoTaxiStatusCountersParams from "./meta-billings-cargo-taxi-status-counters-params";

const create = (
  params: MetaBillingsCargoTaxiStatusCountersParams,
): MetaBillingsCargoTaxiStatusCountersRequest => {
  return {
    cargoCompanyId: params.cargoCompanyId,
    taxiCorporationId: params.taxiCorporationId,
  };
};

const metaBillingsCargoTaxiStatusCountersParamsFactory = {
  create,
};

export default metaBillingsCargoTaxiStatusCountersParamsFactory;
